import type { supportedLocales } from "@/i18n/config";

type SugggestedLanguage = (typeof supportedLocales)[number];

export const getSuggestedLanguage = (
  viewerCountry: string,
): SugggestedLanguage => {
  const countryLanguageMap: Record<string, SugggestedLanguage> = {
    CN: "zh", // China
    TW: "zh-TW", // Taiwan
    HK: "zh-TW", // Hong Kong
    AR: "es-419", // Argentina
    BO: "es-419", // Bolivia
    CL: "es-419", // Chile
    CO: "es-419", // Colombia
    CR: "es-419", // Costa Rica
    CU: "es-419", // Cuba
    DO: "es-419", // Dominican Republic
    EC: "es-419", // Ecuador
    GQ: "es-419", // Equatorial Guinea
    GT: "es-419", // Guatemala
    HN: "es-419", // Honduras
    MX: "es-419", // Mexico
    PA: "es-419", // Panama
    PY: "es-419", // Paraguay
    PE: "es-419", // Peru
    TH: "th", // Thailand
  };

  return countryLanguageMap[viewerCountry] || "en";
};
